import { useLocation } from 'react-router-dom';

import type { BreadcrumbItem as BreadcrumbItemType } from '@/modules/layouts/types';

export function useBreadcrumbs(): BreadcrumbItemType[] {
  const location = useLocation();
  const { pathname, search } = location;

  // Don't show breadcrumbs on standalone top-level pages. This list is
  // separate from hmPages (pages.ts) and is not derived from it, so a new
  // top-level sidebar page needs an entry here too, or it inherits a
  // spurious "Jobs" breadcrumb.
  if (
    pathname === '/hm' ||
    pathname === '/hm/' ||
    pathname === '/hm/integrations' ||
    pathname === '/hm/availability' ||
    pathname === '/hm/interviews' ||
    pathname === '/hm/messages' ||
    pathname === '/hm/billing' ||
    pathname === '/hm/workspace' ||
    pathname === '/hm/chat' ||
    pathname.startsWith('/hm/chat/')
  ) {
    return [];
  }

  // The Slack OAuth result belongs to Integrations, where the user started it.
  if (pathname.startsWith('/hm/slack-connect/')) {
    return [{ title: 'Integrations', path: '/hm/integrations' }];
  }

  const withSearch = (path: string) => `${path}${search}`;

  const items: BreadcrumbItemType[] = [
    { title: 'Jobs', path: withSearch('/hm') },
  ];

  // Match route patterns
  const jobMatch = pathname.match(/^\/hm\/jobs\/([^/]+)/);
  if (jobMatch) {
    const jobId = jobMatch[1];

    const candidateMatch = pathname.match(
      /^\/hm\/jobs\/[^/]+\/candidates\/([^/]+)/,
    );

    if (candidateMatch) {
      // Candidate detail page
      items.push({
        title: 'Candidates',
        path: withSearch(`/hm/jobs/${jobId}/candidates`),
      });
    }
  }

  return items;
}
